module.exports = __webpack_public_path__ + "img/pipe_right_rotate.e6edcbe8.svg";